import { ICreateDirectoryDTO } from '@/api/directories/dtos/create-directory-dto';
import { IUpdateDirectoryDTO } from '@/api/directories/dtos/update-directory-dto';
import { DirectoryQueries } from '@/api/directories/graphql/directory.queries';
import { DirectoryMutations } from '@/api/directories/graphql/directory.mutations';
import { IDirectory } from '@/api/directories/types/directory';
import { apolloClient } from '@/apollo';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class DirectoryService {
  static async loadDirectories(directory: string): Promise<IDirectory[]> {
    const {
      data: { resourceDirectories },
    } = await apolloClient.query({
      query: DirectoryQueries.resourceDirectoriesQuery,
      variables: {
        directory,
      },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return resourceDirectories;
  }

  static async create(payload: ICreateDirectoryDTO): Promise<IDirectory> {
    const {
      data: { createResourceDirectory },
    } = await apolloClient.mutate({
      mutation: DirectoryMutations.createDirectoryMutation,
      variables: { payload },
    });
    return createResourceDirectory;
  }

  static async update(payload: IUpdateDirectoryDTO): Promise<IDirectory> {
    const {
      data: { updateResourceDirectory },
    } = await apolloClient.mutate({
      mutation: DirectoryMutations.updateDirectoryMutation,
      variables: { payload },
    });
    return updateResourceDirectory;
  }

  static async delete(id: string): Promise<IDirectory> {
    const {
      data: { deleteResourceDirectory },
    } = await apolloClient.mutate({
      mutation: DirectoryMutations.deleteDirectoryMutation,
      variables: { id },
    });
    return deleteResourceDirectory;
  }
}
